export { default } from "./dashboard.component";
